export default "__VITE_ASSET__kLrpYb6D__"